import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Eye, Lightning, Brain } from '../components/Icons.jsx';

const drills = [
  { n: '01', icon: Eye, title: 'Learn how to chunk', desc: 'Expand your perceptual span. Read 2–4 words at a time instead of one — the single biggest speed lever in UCAT VR.', link: '/drill/chunk' },
  { n: '02', icon: Lightning, title: 'Eliminate sub-vocalisation', desc: 'A highlighter sweeps through a full passage at your chosen pace. Run a finger under the moving highlight and consciously stop the inner voice.', link: '/drill/sub-vocal' },
  { n: '03', icon: Brain, title: 'Memory trainer', desc: 'The passage is shown for a chosen window, then disappears completely. You must answer four UCAT-style questions from memory — sharpens recall under pressure.', link: '/drill/memory-trainer' }
];

export default function ReadingLab() {
  return (
    <>
      <Link to="/practice" className="back-link"><ArrowLeft width="16" height="16" />Back to trainer</Link>
      <div className="page-head">
        <div className="kicker" style={{ color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 700, fontSize: 12 }}>Speed Reader</div>
        <h1>Reading Lab</h1>
        <p className="subtitle">Three drills, three different reading muscles. Pick one to enter the lab — you'll see the full brief and tuning controls before you begin.</p>
      </div>

      <div className="lab-grid">
        {drills.map((d) => (
          <div key={d.n} className="lab-card">
            <div className="label">Drill {d.n}</div>
            <div className="icon-wrap"><d.icon width="22" height="22" /></div>
            <h3>{d.title}</h3>
            <p>{d.desc}</p>
            {d.link ? (
              <Link to={d.link} className="link">Open drill <ArrowRight width="14" height="14" /></Link>
            ) : (
              <span style={{ color: 'var(--text-faint)', fontSize: 14 }}>Coming soon</span>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
